import { render, staticRenderFns } from "./ListaReservas.vue?vue&type=template&id=f14be74c&"
import script from "./ListaReservas.vue?vue&type=script&lang=js&"
export * from "./ListaReservas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports